// AI usage: AI and data sources, and a custom date range (Kai, 3 Nov 2026).
// The page splits the period's total into AI and Data sources (X post reads,
// Apify scrapes, YouTube reads), and reads a month or a from–to range of
// days. It only points and switches the period: nothing is saved.
// Opened on the page itself: /admin/<customer>/ai-usage?walkthrough=ai-usage-data-sources.

import type { Walkthrough } from './types'

export const aiUsageDataSources: Walkthrough = {
  slug: 'ai-usage-data-sources',
  title: 'AI usage: data sources and date ranges',
  summary:
    'Shows the AI usage page splitting a period into AI and Data sources (X, Apify, YouTube), and reading a date range instead of one month. Nothing is changed.',
  added: '2026-11-03',
  steps: [
    {
      page: 'admin-ai-usage',
      feature: 'billing/ai-usage',
      say: 'This is AI usage, under Management. It shows every team’s use for the period, in our cost, with what was charged beside it. Managers only.',
    },
    {
      page: 'admin-ai-usage',
      feature: 'billing/ai-usage',
      control: 'Filter by X post reads',
      say: 'AI and data sources splits the total in two: AI is every AI feature, Data sources is the X post reads, Apify scrapes and YouTube reads the social import makes, each on its own line. Click a source to filter the page to it. The CSV has a category column, ai or data_source.',
    },
    {
      page: 'admin-ai-usage',
      feature: 'billing/ai-usage',
      click: 'Date range',
      say: 'The page reads one calendar month by default. Date range reads any run of days instead, starting from the month that was on screen.',
    },
    {
      page: 'admin-ai-usage',
      feature: 'billing/ai-usage',
      control: 'End date',
      say: 'Pick a Start date and an End date: UTC days, both included, up to 366 days. Until the range is valid the page keeps the last one and says why under the boxes.',
    },
    {
      page: 'admin-ai-usage',
      feature: 'billing/ai-usage',
      click: 'Month',
      say: 'Month goes back to one calendar month, the range’s first.',
    },
  ],
}
